import React from 'react';
import { Field, useFormikContext } from 'formik';
import { InputAdornment, Grid } from '@mui/material';

import { InputUI, FormErrorUI, FormLabelUI, AutoCompleteSelectUI, DatePickerUI } from '../Interface';

export const DiscountRuleFields = ({ viewField, selectedValues, addField, autocompleteOptions, autocompleteData }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <Grid container spacing={1} my={2} px={2}>
      <Grid item xs={12} md={6}>
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Field
          type="number"
          name="percent"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Százalék" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.percent} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.percent && values.percent !== '' }}
          InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Field
          type="autocomplete"
          name="priceListId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Árlista" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.priceListId} />}
          onChange={(_e, newVal) => {
            setFieldValue('priceListId', newVal?.value ?? null).then(() => {
              validateField('priceListId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.priceListId !== '' }}
          selectedValue={values.priceListId}
          dataset={autocompleteOptions.priceList}
          isOptionEqualToValue={(option, value) => option.value === value}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Field
          type="autocomplete"
          name="customerId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Üp." />}
          variant="standard"
          helperText={<FormErrorUI message={errors.customerId} />}
          onChange={(_e, newVal) => {
            setFieldValue('customerId', newVal?.value ?? null).then(() => {
              validateField('customerId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.customerId !== '' }}
          selectedValue={values.customerId}
          dataset={autocompleteOptions.company}
          isOptionEqualToValue={(option, value) => option.value === value}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Field
          type="autocomplete"
          name="customerGroupId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Üp. csoport" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.customerGroupId} />}
          onChange={(_e, newVal) => {
            setFieldValue('customerGroupId', newVal?.value ?? null).then(() => {
              validateField('customerGroupId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.customerGroupId !== '' }}
          selectedValue={values.customerGroupId}
          dataset={autocompleteOptions.companyGroup}
          isOptionEqualToValue={(option, value) => option.value === value}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Field
          type="autocomplete"
          name="itemCode"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Cikk" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.itemCode} />}
          onChange={(_e, newVal) => {
            setFieldValue('itemCode', newVal?.value ?? null).then(() => {
              validateField('itemCode');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.itemCode !== '' }}
          selectedValue={values.itemCode}
          dataset={autocompleteOptions.item}
          isOptionEqualToValue={(option, value) => option.value === value}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Field
          type="autocomplete"
          name="itemGroupId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Cikkcsoport" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.itemGroupId} />}
          onChange={(_e, newVal) => {
            setFieldValue('itemGroupId', newVal?.value ?? null).then(() => {
              validateField('itemGroupId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.itemGroupId !== '' }}
          selectedValue={values.itemGroupId}
          dataset={autocompleteOptions.itemGroup}
          isOptionEqualToValue={(option, value) => option.value === value}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Field
          type="date"
          name="validFrom"
          component={DatePickerUI}
          value={values.validFrom}
          fullWidth
          label={<FormLabelUI text="Kezdő dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.validFrom} />}
          onChange={(date) => {
            setFieldValue('validFrom', date).then(() => {
              validateField('validFrom');
            });
          }}
          InputLabelProps={{ shrink: values.validFrom !== null }}
          disabled={viewField}
          maxDate={values.validTo || undefined}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Field
          type="date"
          name="validTo"
          component={DatePickerUI}
          value={values.validTo}
          fullWidth
          label={<FormLabelUI text="Záró dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.validTo} />}
          onChange={(date) => {
            setFieldValue('validTo', date).then(() => {
              validateField('validTo');
            });
          }}
          InputLabelProps={{ shrink: values.validTo !== null }}
          disabled={viewField}
          minDate={values.validFrom || undefined}
        />
      </Grid>
    </Grid>
  );
};

export default DiscountRuleFields;
